import { DataReader } from "./DataReader";
import { Vertex, Face } from "@spi/Common/Geometry";
import { SerializationUtil } from "./SerializationUtil";
import { GeometryContainer } from "@spi/Common/Geometry";

export class GeometryReader extends DataReader<GeometryContainer> {

    public read(data: Uint8Array): GeometryContainer {
        let util = new SerializationUtil().readFrom(data, true);
        let container = new GeometryContainer();

        container.reference = util.readString();
        container.textureReference = util.readString();
        container.type = util.readUint8();

        let vertexCount = util.readUint32();
        let vertices = new Array<Vertex>(vertexCount);
        
        for (let i = 0; i < vertexCount; i++) {
            vertices[i] = new Vertex()
                .setPosition(util.readVec3(), true)
                .setNormal(util.readVec3(), true)
                .setColor(util.readVec4(), true);
        }

        let faceCount = util.readUint32();
        let faces = new Array<Face>(faceCount);
        
        for (let i = 0; i < faceCount; i++) {

            let face = new Face();
            face.vertices = [];
            for (let v = 0; v < 3; v++) {
                let vertex = vertices[util.readUint32()];
                face.vertices.push(vertex)
                face.setTextureOffset(vertex, util.readVec2());
            }
            face.attachToVertices();
            face.setNormal(util.readVec3())
                .setTraversability(util.readUint8());

            faces[i] = face;
        }

        container.faces = faces;

        return container;
    }

}